<template>

    <v-container>

        <v-card-title>
            <v-col class="d-flex flex-column justify-center align-center">
                <div class="deep-orange--text font-weight-bold display-1">{{$t('dash_overview.visualization')}}</div>
                <div class="caption">{{$t('dash_overview.daily_evo')}}</div>
            </v-col>
        </v-card-title>
        
        <area-chart class="area-byday-chart chart-area" v-if="chartData" :data='chartData' :colors="colors"> </area-chart>

    </v-container>
 
</template>

<script>

export default {

    name: 'ImpressionByDayChartContainer',

    props: ['chartData'],

    data() {
        
        return {

            colors: [
                '#9e9e9e',
                '#4caf50',
                '#e91e63',
                '#2196f3',
                '#ff9800',
                '#654287'
            ]

        }


    }

}

</script>

<style>

</style>